import { useState } from "react";
import { useTranslation } from "@i18n";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import stl from "./DmanProgram.module.css";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";

const SingleDmanBox = (props) => {
  const { t } = useTranslation();
  const {createUrl} = useHelpers();
  const [ShowPopUp, setShowPopUp] = useState(false);
  return (
    <>
      <div
        className={stl.DmanBoxContainer}
        onClick={() => {
          setShowPopUp(true);
          // uspViewEvent(props.text, props.g4_data);
          trackEvents("usp_view", {
            ...props.g4_data,
            usp_type: props.text.replace(/100/g, "200"),
          });
        }}
      >
        <img src={props.icn} alt="icon" loading="eager" width={"52px"} height={"51px"}/>
        <strong>{props.text.replace(/100/g, "200")}</strong>
        <span>{t("المزيد",{ns:"web_common"})}</span>
      </div>
      <BottomSheetPopup
        show={ShowPopUp}
        onClose={() => {
          setShowPopUp(false);
        }}
        className={stl.customPostViewPopup}
      >
        <div className={stl.PopUpText}>
          <div className={stl.popUpContentsSDB}>
            <strong>
              <img src={props.icn} alt="icon" />
              <span>{props.text.replace(/100/g, "200")}</span>
            </strong>
            <p>{props.content.replace(/100/g, "200")}</p>
          </div>
        </div>
        <div className={stl.termsAndConditions}>
          <a href={createUrl("/car-purchase-terms-conditions")}>
            {t("تطبق الشروط والأحكام", { ns: "web_post_view" })}
          </a>
        </div>
      </BottomSheetPopup>
    </>
  );
};

export default SingleDmanBox;
